import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider } from './context/AuthContext'
import { NotificationProvider } from './context/NotificationContext'
import { ExecutionProvider } from './context/ExecutionContext'
import { ToastProvider, ToastContainer } from './context/ToastContext'
import { MarketDataProvider } from './context/MarketDataContext'
import { SSEProvider } from './hooks/useSSE'
import { App } from './App'
import './styles/global.css'
import './styles/light-fix.css'
import './styles/mobile.css'

// Register push notification service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(console.error)
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <NotificationProvider>
          <ToastProvider>
            <ExecutionProvider>
              <SSEProvider>
                <MarketDataProvider>
                  <App />
                  <ToastContainer />
                </MarketDataProvider>
              </SSEProvider>
            </ExecutionProvider>
          </ToastProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
)
